import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-rewards',
    templateUrl: './icon-rewards.component.html',
    styleUrls: ['./icon-rewards.component.scss']
})
export class IconRewardsComponent implements OnInit {

    @Input() cssClass: string;

    constructor() { }

    ngOnInit(): void {
    }

}
